import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Searchs from './Searchs';

const mapStateToProps = ({ layout: { locale, admin, userPermissions } }) => ({ locale, admin, userPermissions });

export default withRouter(connect(mapStateToProps, null)(Searchs));
